import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { NgbCollapseModule, NgbDatepickerModule, NgbTimepickerModule, NgbDropdownModule, NgbAccordionModule, NgbPaginationModule, NgbTypeaheadModule } from '@ng-bootstrap/ng-bootstrap';

import { MillDashboardSharedComponent } from './milldashboard.shared.component';
import { UIModule } from '../ui/ui.module';
import { NgxMaskModule } from 'ngx-mask';

import { NgApexchartsModule } from 'ng-apexcharts';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxSpinnerModule } from 'ngx-spinner';

import { TreeviewModule } from 'ngx-treeview';
import { DropdownTreeviewSelectModule } from '../helper/dropdownTreeviewSelect/dropdown-treeview-select.module';


@NgModule({
  declarations: [MillDashboardSharedComponent],
  imports: [
    CommonModule,
    FormsModule,
    NgbCollapseModule,
    NgbDatepickerModule,
    NgbTimepickerModule,
    NgbDropdownModule,
    NgbAccordionModule,
    NgbPaginationModule,
    NgbTypeaheadModule,
    UIModule,
    NgApexchartsModule,
    NgSelectModule,
    NgxSpinnerModule,
    NgxMaskModule.forRoot(),
    TreeviewModule.forRoot(),
    DropdownTreeviewSelectModule
  ],
  exports: [MillDashboardSharedComponent]
})
export class MillDashboardSharedModule { }
